import { Directive, Signal, TemplateRef } from '@angular/core';

@Directive()
export abstract class AbstractVerticalTabGroup {
  abstract readonly label: Signal<string>;
  abstract readonly labelTemplate: Signal<TemplateRef<unknown> | undefined>;

  abstract readonly isSelected: Signal<boolean>;

  abstract updateSelectedState(state: boolean): void;
}
